<template>
  <elwrapper label="Attachments" texttop>
    <div class="grey lighten-2 pa-2" v-if="value && value.length">
      <v-icon left>attach_file</v-icon>
      <v-chip
        color="primary"
        v-for="(file, index) in value"
        :key="file.lastModified"
        class="mx-1"
        @click="openAttachment(file.key)"
      >
        <span>{{ file.filename }}</span>
        <v-btn small icon @click="(e) => removeFile(e, index)">
          <v-icon small>clear</v-icon>
        </v-btn>
      </v-chip>
    </div>

    <div class="d-flex align-center">
      <v-file-input
        outlined
        dense
        hide-details
        show-size
        multiple
        prepend-icon="attach_file"
        :value="placeHolderValue"
        @change="setFile"
        :loading="loading"
        :disabled="loading"
      />

      <v-btn v-for="(b, index) in buttons" :key="'button' + index" @click="b.onclick" small text color="primary">
        {{ b.text }}
      </v-btn>
    </div>
    <span class="subtitle-2">** Maximum file upload: 50MB</span>
  </elwrapper>
</template>

<script>
// import { ipcRenderer } from 'electron'
export default {
  props: {
    value: Array,
    buttons: Array,
  },
  data() {
    return {
      placeHolderValue: [],
      loading: false,
    };
  },
  methods: {
    setFile(files) {
      const file = files[0];
      if (!file) return;

      this.loading = true;
      this.$store
        .dispatch("StorageStore/uploadFile", { name: file.name, file: file })
        .then((data) => {
          let extract = { filename: file.name, key: data.key };
          if (!this.value) this.$emit("input", [extract]);
          else this.$emit("input", [...this.value, extract]);
          this.placeHolderValue = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeFile(e, index) {
      e.stopPropagation();
      let modifer = [...this.value];
      modifer.splice(index, 1);
      this.$emit("input", modifer);
    },
    openAttachment(key) {
      const url = this.$store.getters["host"] + "storage/" + key;
      window.open(url, "_blank");
    },
  },
};
</script>
